/* eslint-disable max-classes-per-file */
export class RouteError extends Error {}
export class NotFount extends Error {}
